// reCAPTCHA v3 - invisible, scores every submission; the script is loaded in index.html with the same key
export const recaptchaSiteKey = '6LeqsPgtAAAAACw2HOthGGXe5LjNAMPCBUF_ZHx9'

/**
 * Token for one form submission. It is valid for two minutes and only once, so get it right before sending.
 * The action must match the one the server expects for the endpoint.
 */
export function getRecaptchaToken(action: string): Promise<string> {
	return new Promise((resolve, reject) => {
		const grecaptcha = (window as any).grecaptcha

		if (!grecaptcha || typeof grecaptcha.ready !== 'function') {
			reject(new Error('reCAPTCHA is not loaded'))
			return
		}

		grecaptcha.ready(() => {
			grecaptcha.execute(recaptchaSiteKey, { action }).then(resolve, reject)
		})
	})
}
